// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R1QDr","colBig":"styles_colBig__z0A-E","colSmall":"styles_colSmall___LWNX","shopifyNameWrapper":"styles_shopifyNameWrapper__2ja-k"};